/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Which rows a role can reach: all rows, its organisation's rows, or its user's rows. */
export type UserScope =
  | 'GLOBAL'
  | 'ORG'
  | 'USER';

export type LoginMutationVariables = Exact<{
  username: string;
  password: string;
}>;


export type LoginMutation = { login: { token: unknown, shouldChangePassword: boolean | null, user: { id: string, username: string | null, email: string | null, organisationId: string | null, role: string, scope: UserScope | null } | null } | null };

export type UserQueryVariables = Exact<{
  userId: unknown;
}>;


export type UserQuery = { user: { id: string, username: string | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const LoginDocument = new TypedDocumentString(`
    mutation Login($username: String!, $password: String!) {
  login(data: {username: $username, password: $password}) {
    user {
      id
      username
      email
      organisationId
      role
      scope
    }
    token
    shouldChangePassword
  }
}
    `) as unknown as TypedDocumentString<LoginMutation, LoginMutationVariables>;
export const UserDocument = new TypedDocumentString(`
    query User($userId: RoyID!) {
  user(where: {id: $userId}) {
    id
    username
  }
}
    `) as unknown as TypedDocumentString<UserQuery, UserQueryVariables>;